import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import STRING_KEYS from '../../../language/keys';
import { ConfirmationDialogType } from '../../../consts/enums';
import style from './style';

type Props = {
  title: string,
  subTitle?: string,
  btnTitle: string,
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean,
  type?: ConfirmationDialogType,
}
const ConfirmationDialog = (props: Props):JSX.Element => {
  const {
    onConfirm, onClose, title, btnTitle, subTitle, type, isOpen,
  } = props;
  const { t: translate } = useTranslation();

  return (
    <Dialog
      open={ isOpen }
      onClose={ onClose }
      onClick={ (e) => e.stopPropagation() }
      fullWidth
    >
      <DialogTitle sx={ style.dialogTitle }>
        <Box sx={ style.titleBox }>
          <Typography variant={ style.titleVariant }>
            { title }
          </Typography>
          <IconButton
            onClick={ onClose }
            sx={ style.closeIcon }
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      { subTitle && (
        <DialogContent>
          <DialogContentText>
            { subTitle }
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions
        sx={ style.dialogAction }
      >
        <Button onClick={ (e) => {
          e.stopPropagation();
          onClose();
        } }
        >
          { translate(STRING_KEYS.DIALOG.BTN_GO_BACK) }
        </Button>
        <Button
          variant="contained"
          onClick={ (e) => {
            e.stopPropagation();
            onConfirm();
          } }
          color={ type }
        >
          { btnTitle }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.defaultProps = {
  subTitle: undefined,
  type: ConfirmationDialogType.primary,
};

export default memo(ConfirmationDialog);
